import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import zoneFile from 'dns-zonefile'

import { useDnsStore } from '@/store/DNS.store'
import { ZONE_FILE_TEMPLATE } from '@/configs/dnsZoneFileTemplate.config'
import { useDecimaleEscapeFormatter } from '@/utils/composables/useDecimaleEscapeFormatter'

export const useFileCreator = () => {
  const dnsStore = useDnsStore()
  const { currentZone, records } = storeToRefs(dnsStore)
  const { encode } = useDecimaleEscapeFormatter()

  const zoneFileObject = computed(() => {
    return {
      $origin: currentZone.value.name,
      $ttl: currentZone.value.ttl,
      soa: {
        name: currentZone.value.name,
        ttl: currentZone.value.ttl,
        mname: currentZone.value.nameserver,
        rname: currentZone.value.hostmaster,
        serial: currentZone.value.serial,
        refresh: currentZone.value.refresh,
        retry: currentZone.value.retry,
        expire: currentZone.value.expire,
        minimum: currentZone.value.minimum
      },
      ns: records.value
        .filter(r => r.type === 'NS')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            host: r.content
          }
        }),
      ptr: records.value
        .filter(r => r.type === 'PTR')
        .map(r => {
          return {
            name: r.name,
            fullname: r.name,
            ttl: r.ttl,
            host: r.content
          }
        }),
      a: records.value
        .filter(r => r.type === 'A')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            ip: r.content
          }
        }),
      aaaa: records.value
        .filter(r => r.type === 'AAAA')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            ip: r.content
          }
        }),
      txt: records.value
        .filter(r => r.type === 'TXT')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            txt: encode(r.content)
          }
        }),
      cname: records.value
        .filter(r => r.type === 'CNAME')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            alias: r.content
          }
        }),
      mx: records.value
        .filter(r => r.type === 'MX')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            preference: Number(r.content.split(' ')[0]),
            host: r.content.split(' ')[1]
          }
        }),
      srv: records.value
        .filter(r => r.type === 'SRV')
        .map(r => {
          return {
            name: r.name,
            ttl: r.ttl,
            priority: Number(r.content.split(' ')[0]),
            weight: Number(r.content.split(' ')[1]),
            port: Number(r.content.split(' ')[2]),
            target: r.content.split(' ')[3]
          }
        })
    }
  })

  const output = zoneFile.generate(zoneFileObject.value, ZONE_FILE_TEMPLATE)

  // Создаем Blob-объект с текстом
  const blob = new Blob([output], { type: 'text/plain' })

  // Создаем временную ссылку
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `platformcraft_${currentZone.value.name.replaceAll('.', '_')}`

  // Имитируем клик для скачивания
  document.body.appendChild(link)
  link.click()

  // Убираем ссылку из DOM
  setTimeout(() => {
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  }, 0)

  return {
    zoneFileObject
  }
}
